import React, { useEffect, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBold,
  faCode,
  faHeading,
  faImage,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faQuoteRight,
  faStrikethrough
} from '@fortawesome/free-solid-svg-icons';
import FileInputModal from "./FileInputModal";
import "../../styling/ForumAnswer.css";

export default function ForumAnswer() {
  const [forumAnswerText, setForumAnswerText] = useState("<p></p>");

  const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({ openOnClick: false }),
      Image,
    ],
    content: forumAnswerText,
    editorProps: {
      attributes: { class: "wiki-editor" },
    },
    onUpdate: ({ editor }) => {
      setForumAnswerText(editor.getHTML());
    },
  });

  if (!editor) return null;

  return (
    <div>
        <div className="wiki-toolbar">
            <button
            title="Bold"
            className={editor.isActive("bold") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleBold().run()}
            >
                <FontAwesomeIcon icon={faBold} />
            </button>

            <button
            title="Italic"
            className={editor.isActive("italic") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleItalic().run()}
            >
                <FontAwesomeIcon icon={faItalic} />
            </button>

            <button
            title="Strikethrough"
            className={editor.isActive("strike") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleStrike().run()}
            >
                <FontAwesomeIcon icon={faStrikethrough} />
            </button>

            <div className="wiki-toolbar-sep" />

            <button
            title="Heading 2"
            className={editor.isActive("heading", { level: 2 }) ? "active" : ""}
            onClick={() =>
                editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            >
                <FontAwesomeIcon icon={faHeading} />
            </button>

            <button
            title="Bulleted List"
            className={editor.isActive("bulletList") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            >
                <FontAwesomeIcon icon={faListUl} />
            </button>

            <button
            title="Numbered List"
            className={editor.isActive("orderedList") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            >
                <FontAwesomeIcon icon={faListOl} />
            </button>

            <button
            title="Quote"
            className={editor.isActive("blockquote") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleBlockquote().run()}
            >
                <FontAwesomeIcon icon={faQuoteRight} />
            </button>

            <button
            title="Code Block"
            className={editor.isActive("codeBlock") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleCodeBlock().run()}
            >
                <FontAwesomeIcon icon={faCode} />
            </button>

            <div className="wiki-toolbar-sep" />

            <button title="Insert Link">
                <FontAwesomeIcon icon={faLink} />
            </button>

            <button title="Insert Image" data-bs-toggle="modal" data-bs-target="#exampleModal">
                <FontAwesomeIcon icon={faImage} />
            </button>
        </div>

        <div className="wiki-editor-shell">
            <EditorContent editor={editor} />
        </div>

        <FileInputModal />
    </div>
  );
}
